/*
 * File: index.ts
 * Project: meki
 * File Created: Monday, 21st September 2020 5:35:28 pm
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Friday, 3rd February 2023 9:38:17 am
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */
export * from './user.interface';
export * from './product.interface';
export * from './address.interface';
export * from './paymentMethod.interface';
export * from './prescription.interface';
export * from './order.interface';
export * from './price.interface';
export * from './orderDetail.interface';
export * from './permission.interface';
export * from './availability.interface';
export * from './suggestion.interface';
export * from './category.interface';
export * from './subCategory.interface';
export * from './productsAvailabilityList.interface';
export * from './receipt.interface';
export * from './terms.interface';
export * from './pillBox.interface';
export * from './pillBoxDetail.interface';
export * from './payment.interface';
export * from './requestedUnavailableProducts.interface';
export * from './biometricLogin.interface';
export * from './referenceCoupon.interface';
